import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { SplashScreen } from '../../features/onboarding/screens/SplashScreen';
import { OnboardingFlowScreen } from '../../features/onboarding/screens/OnboardingFlowScreen';
import { MainTabsShell } from '../shell/MainTabsShell';
import { ExploreScreen } from '../../features/explore/screens/ExploreScreen';
import { ProfileScreen } from '../../features/profile/screens/ProfileScreen';
import { BillingScreen } from '../../features/billing/screens/BillingScreen';
import { AuthScreen } from '../../features/auth/screens/AuthScreen';
import { AuthCallbackScreen } from '../../features/auth/screens/AuthCallbackScreen';
import { ProtectedRoute } from './ProtectedRoute';

export const AppRouter: React.FC = () => {
  return (
    <div className="flex min-h-0 flex-1 flex-col">
      <Routes>
        <Route path="/splash" element={<SplashScreen />} />
        <Route path="/auth" element={<AuthScreen />} />
        <Route path="/auth/callback" element={<AuthCallbackScreen />} />
        <Route path="/welcome" element={<Navigate to="/app/explore" replace />} />
        <Route
          path="/onboarding/*"
          element={
            <ProtectedRoute>
              <OnboardingFlowScreen />
            </ProtectedRoute>
          }
        />
        <Route
          path="/app"
          element={
            <ProtectedRoute>
              <MainTabsShell />
            </ProtectedRoute>
          }
        >
          <Route index element={<Navigate to="explore" replace />} />
          <Route path="explore" element={<ExploreScreen />} />
          <Route path="billing" element={<BillingScreen />} />
          <Route path="profile" element={<ProfileScreen />} />
        </Route>
        <Route path="/" element={<Navigate to="/splash" replace />} />
        <Route path="*" element={<Navigate to="/splash" replace />} />
      </Routes>
    </div>
  );
};

